module.exports = __webpack_public_path__ + "static/img/ES@3x.44ece645.png";